/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowUiShareAImportIcon16Light } from './ArrowUiShareAImportIcon16Light';
import { ArrowUiShareAImportIcon16Regular } from './ArrowUiShareAImportIcon16Regular';
import { ArrowUiShareAImportIcon16Solid } from './ArrowUiShareAImportIcon16Solid';
import { ArrowUiShareAImportIcon20Light } from './ArrowUiShareAImportIcon20Light';
import { ArrowUiShareAImportIcon20Regular } from './ArrowUiShareAImportIcon20Regular';
import { ArrowUiShareAImportIcon20Solid } from './ArrowUiShareAImportIcon20Solid';
import { ArrowUiShareAImportIcon24Regular } from './ArrowUiShareAImportIcon24Regular';
import { ArrowUiShareAImportIcon24Solid } from './ArrowUiShareAImportIcon24Solid';
import { ArrowUiShareAImportIcon32Regular } from './ArrowUiShareAImportIcon32Regular';
import { ArrowUiShareAImportIcon64Regular } from './ArrowUiShareAImportIcon64Regular';
var sizes = {
    16: {
        light: ArrowUiShareAImportIcon16Light,
        regular: ArrowUiShareAImportIcon16Regular,
        solid: ArrowUiShareAImportIcon16Solid,
    },
    20: {
        light: ArrowUiShareAImportIcon20Light,
        regular: ArrowUiShareAImportIcon20Regular,
        solid: ArrowUiShareAImportIcon20Solid,
    },
    24: {
        regular: ArrowUiShareAImportIcon24Regular,
        solid: ArrowUiShareAImportIcon24Solid,
    },
    32: {
        regular: ArrowUiShareAImportIcon32Regular,
    },
    64: {
        regular: ArrowUiShareAImportIcon64Regular,
    },
};
export var ArrowUiShareAImportIcon = forwardRef('ArrowUiShareAImportIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
